import type { RouterOutputs } from 'shared/api'

type IncomingPlace = keyof NonNullable<RouterOutputs['remainders']['AtPoint']['parcels']>['incoming']['places']

/** The order the places of "on its way to the Point" are listed in: nearest to the Point last (ticket 47). */
export const INCOMING_PLACES: readonly IncomingPlace[] = [
	'at_hub',
	'bag_at_hub',
	'bag_with_driver',
	'with_driver',
	'at_other_point',
	'arrived',
]

/** An amount as the remainders show it: `42 000` — the currency («сум») is in the label, once. */
export function formatSum(amount: number): string {
	return amount.toLocaleString('ru-RU')
}

/**
 * Table options for a list that comes whole from the server: no paging, sorting or
 * filtering on the server, one page with every row.
 */
export const WHOLE = {
	manualPagination: false,
	manualSorting: false,
	manualFiltering: false,
	enableRowSelection: false,
	initialState: { pagination: { pageIndex: 0, pageSize: 10000 } },
} as const
